import { render, staticRenderFns } from "./ModalDeleteCriteria.vue?vue&type=template&id=23ac1dcc&scoped=true&"
import script from "./ModalDeleteCriteria.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac1dcc",
  null
  
)

export default component.exports